import { Component } from '@angular/core';
import { BaseDialogComponent } from '../../../../../../../components/kit/base-dialog/base-dialog.component';
import { TextInputComponent } from '../../../../../../../components/kit/input/text-input/text-input.component';
import { fb } from '../../../../../../shared/shared.global-service';
import { Validators } from '@angular/forms';
import { CheckInputComponent } from '../../../../../../../components/kit/input/check-input/check-input.component';

@Component({
    selector: 'app-service-settings-visit-type-upsert-dialog',
    templateUrl: 'service-settings-visit-type-upsert-dialog.component.html',
    styleUrl: 'service-settings-visit-type-upsert-dialog.component.scss',
    imports: [
        TextInputComponent,
        CheckInputComponent,
    ]
})
export class ServiceSettingsVisitTypeUpsertDialogComponent extends BaseDialogComponent {

    protected prefix = 'service.settings.general.visitType.';

    protected form = fb.group({
        active: fb.control(true),
        name: fb.control('', Validators.required),
        description: fb.control(''),
    });

    constructor() {
        super();
        this.form.patchValue({
            active: this.dialogConfig.data.item?.active || this.form.value.active,
            name: this.dialogConfig.data.item?.name || this.form.value.name,
            description: this.dialogConfig.data.item?.description || this.form.value.description,
        });
    }

    public override save(): void {
        this.dialogRef.close(this.form.value);
    }

}
